import { toast } from "react-hot-toast";
import httpf from "utils/api/frontend/httpf";
import { QOOHOO_WEBSITE_DOMAIN } from "constants/env";
import { getLocalTimezone } from "@qoohoo/common/constants/country";

export default async function getIpInfo({ setUserIpInfo }) {
  const timezone = getLocalTimezone();

  httpf
    .get(`${QOOHOO_WEBSITE_DOMAIN}/api/ipinfo?timezone=${timezone}`)
    .then((res) => {
      // console.log(res);
      setUserIpInfo(res.data);
    })
    .catch((err) => {
      //   console.log(err);
      const error = err.response?.data?.message || err.message;
      if (error) {
        // toast.error(error);
      }
    });
}
